import { render, staticRenderFns } from "./SetAsApprover.vue?vue&type=template&id=5023c2b5&scoped=true"
import script from "./SetAsApprover.vue?vue&type=script&lang=js"
export * from "./SetAsApprover.vue?vue&type=script&lang=js"
import style0 from "./SetAsApprover.vue?vue&type=style&index=0&id=5023c2b5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023c2b5",
  null
  
)

export default component.exports